import React, { useEffect, useState } from "react";
import { Spin, message } from "antd";
import { getAuth } from "firebase/auth";
import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import { useNavigate } from "react-router-dom";

export default function PayerEnLigne() {
  const uid = getAuth().currentUser?.uid;
  const navigate = useNavigate();
  const [info, setInfo] = useState({ fullname: "", email: "", Credit: 0 });
  const [weekPlans, setWeekPlans] = useState([]);
  const [monthPlans, setMonthPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [payingKey, setPayingKey] = useState(null);
  const [dark, setDark] = useState(() => localStorage.getItem("ws-theme") === "dark");

  const toggleTheme = () => {
    setDark(d => {
      localStorage.setItem("ws-theme", !d ? "dark" : "light");
      return !d;
    });
  };

  const t = dark ? theme.dark : theme.light;

  useEffect(() => {
    async function init() {
      if (!uid) return;
      const [cSnap, snap] = await Promise.all([
        getDocs(query(collection(db, "contact"), where("FirebaseId", "==", uid))),
        getDoc(doc(db, "administration", "Abonnement")),
      ]);
      if (!cSnap.empty) {
        const d = cSnap.docs[0].data();
        setInfo({ fullname: d.fullname, email: d.email, Credit: d.Credit || 0 });
      }
      if (snap.exists()) {
        const d = snap.data();
        const hrs = d["hours membership"];
        setWeekPlans(hrs.map((h, i) => ({ hours: +h, price: d.Weekpricing[i] })));
        setMonthPlans(hrs.map((h, i) => ({ hours: +h, price: d.Monthpricing[i] })));
      }
      setLoading(false);
    }
    init();
  }, [uid]);

  const handlePay = async ({ type, hours, price, key }) => {
    setPayingKey(key);
    try {
      const res = await fetch("http://localhost:5000/api/konnect/pay", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ amount: price, email: info.email, fullname: info.fullname, metadata: { type, hours } }),
      });
      const json = await res.json();
      if (json.redirectUrl) {
        window.open(json.redirectUrl, "_blank");
      } else {
        message.error(json.error || "Erreur paiement");
      }
    } catch {
      message.error("Communication avec le serveur impossible");
    } finally {
      setPayingKey(null);
    }
  };

  if (loading) return (
    <div style={{ background: t.bg, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Spin size="large" />
    </div>
  );

  return (
    <div style={{ background: t.bg, minHeight: "100vh" }}>
      <div style={{ maxWidth: 900, margin: "0 auto", paddingBottom: 40 }}>

        {/* Topbar */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 18px 0", flexWrap: "wrap", gap: 10 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <img src="/logo.PNG" alt="WeStudy" style={{ height: 40, objectFit: "contain" }} />
            <div>
              <div style={{ fontSize: 15, fontWeight: 600, color: t.text1 }}>Payer en ligne</div>
              <div style={{ fontSize: 11, color: t.text2 }}>Abonnements & crédits</div>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <button onClick={toggleTheme} style={{ ...s.toggleTrack, background: t.bg3, border: `1px solid ${t.border}` }}>
              <div style={{ ...s.toggleKnob, background: t.blue, transform: dark ? "translateX(16px)" : "translateX(0)" }} />
            </button>
            <button onClick={() => navigate("/")} style={{ ...s.outlineBtn, background: t.bg3, border: `1px solid ${t.border}`, color: t.text2 }}>
              ← Retour
            </button>
          </div>
        </div>

        {/* User info card */}
        <div style={{ padding: "20px 18px 0" }}>
          <div style={{ background: t.cardBg, border: `1px solid ${t.border}`, borderRadius: 14, padding: "14px 16px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 500, color: t.text1 }}>👤 {info.fullname}</div>
              <div style={{ fontSize: 11, color: t.text2, marginTop: 2 }}>{info.email}</div>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontSize: 11, color: t.text2 }}>Crédit dû</div>
                <div style={{ fontSize: 18, fontWeight: 600, color: info.Credit > 0 ? t.red : t.green }}>
                  {info.Credit} dt
                </div>
              </div>
              {info.Credit > 0 && (
                <button
                  onClick={() => handlePay({ type: "credit", hours: 0, price: info.Credit, key: "credit" })}
                  disabled={payingKey === "credit"}
                  style={{ ...s.payBtn, background: t.red, opacity: payingKey === "credit" ? 0.7 : 1 }}
                >
                  {payingKey === "credit" ? "..." : "Régler le crédit"}
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Weekly plans */}
        {weekPlans.length > 0 && (
          <>
            <SectionLabel label="Abonnements hebdomadaires" t={t} />
            <ResponsiveGrid cols3>
              {weekPlans.map(o => (
                <PlanCard
                  key={`week-${o.hours}`}
                  hours={o.hours}
                  price={o.price}
                  period="semaine"
                  payingKey={payingKey}
                  onPay={() => handlePay({ type: "membership", hours: o.hours, price: o.price, key: `week-${o.hours}` })}
                  cardKey={`week-${o.hours}`}
                  t={t}
                />
              ))}
            </ResponsiveGrid>
          </>
        )}

        {/* Monthly plans */}
        {monthPlans.length > 0 && (
          <>
            <SectionLabel label="Abonnements mensuels" t={t} />
            <ResponsiveGrid cols3>
              {monthPlans.map(o => (
                <PlanCard
                  key={`month-${o.hours}`}
                  hours={o.hours}
                  price={o.price}
                  period="mois"
                  payingKey={payingKey}
                  onPay={() => handlePay({ type: "membership", hours: o.hours, price: o.price, key: `month-${o.hours}` })}
                  cardKey={`month-${o.hours}`}
                  t={t}
                />
              ))}
            </ResponsiveGrid>
          </>
        )}

        {/* Konnect note */}
        <div style={{ margin: "16px 18px 0", padding: "10px 14px", background: t.blueBg, border: `1px solid ${t.border}`, borderRadius: 12, fontSize: 12, color: t.blueText }}>
          🔒 Paiement sécurisé via <strong>Konnect</strong> · Vous serez redirigé vers la page de paiement
        </div>
      </div>
    </div>
  );
}

function SectionLabel({ label, t }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "20px 18px 10px" }}>
      <span style={{ fontSize: 11, fontWeight: 500, color: t.text3, letterSpacing: "0.08em", textTransform: "uppercase" }}>{label}</span>
      <div style={{ flex: 1, height: 1, background: t.border }} />
    </div>
  );
}

function PlanCard({ hours, price, period, onPay, cardKey, payingKey, t }) {
  const [hovered, setHovered] = useState(false);
  const isPaying = payingKey === cardKey;

  return (
    <div
      style={{
        background: hovered ? t.bg3 : t.cardBg,
        border: `1px solid ${hovered ? t.blue : t.border}`,
        borderRadius: 14,
        padding: 16,
        display: "flex",
        flexDirection: "column",
        gap: 10,
        transition: "border-color 0.15s, background 0.15s",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={{ width: 38, height: 38, borderRadius: 10, background: t.blueBg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>
        ⏱️
      </div>
      <div>
        <div style={{ fontSize: 14, fontWeight: 600, color: t.text1 }}>{hours}h / {period}</div>
        <div style={{ fontSize: 20, fontWeight: 700, color: t.blue, marginTop: 4 }}>{price} <span style={{ fontSize: 13, fontWeight: 400, color: t.text2 }}>dt</span></div>
      </div>
      <button
        onClick={onPay}
        disabled={isPaying}
        style={{ ...s.payBtn, background: t.blue, width: "100%", opacity: isPaying ? 0.7 : 1 }}
      >
        {isPaying ? "Redirection..." : "💳 Payer"}
      </button>
    </div>
  );
}

function ResponsiveGrid({ children, cols3 }) {
  const [cols, setCols] = useState(1);
  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (cols3) {
        setCols(w >= 900 ? 3 : w >= 560 ? 2 : 1);
      } else {
        setCols(w >= 640 ? 2 : 1);
      }
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [cols3]);
  return (
    <div style={{ display: "grid", gridTemplateColumns: `repeat(${cols}, minmax(0,1fr))`, gap: 10, padding: "0 18px" }}>
      {children}
    </div>
  );
}

const theme = {
  light: {
    bg: "#f8fafc", bg3: "#f1f5f9", border: "#e2e8f0",
    text1: "#0f172a", text2: "#64748b", text3: "#94a3b8",
    blue: "#2563eb", blueBg: "#eff6ff", blueText: "#1d4ed8",
    green: "#16a34a", red: "#dc2626",
    cardBg: "#ffffff",
  },
  dark: {
    bg: "#0f172a", bg3: "#1a2740", border: "#273549",
    text1: "#f1f5f9", text2: "#94a3b8", text3: "#475569",
    blue: "#378ADD", blueBg: "#1e3a5f", blueText: "#85B7EB",
    green: "#4ade80", red: "#f87171",
    cardBg: "#1e293b",
  },
};

const s = {
  toggleTrack: { width: 36, height: 20, borderRadius: 20, cursor: "pointer", position: "relative", flexShrink: 0 },
  toggleKnob: { width: 14, height: 14, borderRadius: "50%", position: "absolute", top: 2, left: 2, transition: "transform 0.2s" },
  outlineBtn: { fontSize: 12, borderRadius: 8, padding: "6px 10px", cursor: "pointer" },
  payBtn: { border: "none", borderRadius: 10, color: "#fff", fontSize: 13, fontWeight: 600, padding: "9px 16px", cursor: "pointer", transition: "opacity 0.15s", whiteSpace: "nowrap" },
};